<template>
    <div class="country-detail">
        <div class="shoreBanner">
          <img v-if="!cityDetail.videoUrl" :src="cityDetail.cityBannerUrl" alt="">
          <Destination-video v-else :coverUrl="cityDetail.videoImage"
                             :videoUrl="cityDetail.videoUrl"
                             :isShowTextBtn="true"
          ></Destination-video>
        </div>
        <div class="shore--container">

            <div class="pcpShorex-countrySelect">
                <div class="container">
                    <div class="row">
                        <!--国家和城市-->
                        <div class="shore--country">
                            <!--国家-->
                            <div>
                                <span>国家和地区</span>
                                <div class="dropdown dropdown--country" v-bind:class="{open: isShowCountryDrop}" @mouseover="handleShowCountryDrop" @mouseleave="handleHideCountryDrop">
                                    <button type="button" class="btn dropdown-toggle btn--country">
                                        <span class="name">{{countryModel.countryCNName}}</span>
                                        <span class="dropImg">
                                            <img class="down" src="https://resource.rcclchina.com.cn/shoreExcursionNew/image/shoreBtm.png">
                                            <img class="up" src="https://resource.rcclchina.com.cn/shoreExcursionNew/image/shoreTop.png">
                                        </span>
                                    </button>
                                    <ul class="dropdown-menu menu--country">
                                        <li v-for="item in countryModels" :key="item.id" class="China">
                                            <a role="menuitem" tabindex="-1" class="countryName" href="javascript: void(0)" @click="handleSelectCountry(item)">{{item.countryCNName}}</a>
                                        </li>
                                    </ul>
                                    <div class="dropdown-menuArrow"></div>
                                </div>
                            </div>
                            <!--城市-->
                            <div>
                                <span>选择观光城市</span>
                                <div class="dropdown dropdown--pend dropdown--city" v-bind:class="{open: isShowCityDrop}" @mouseover="handleShowCityDrop" @mouseleave="handleHideCityDrop">
                                    <button type="button" class="btn dropdown-toggle btn--city">
                                        <span class="name">{{cityText}}</span>
                                        <span class="dropImg">
                                            <img class="down" src="https://resource.rcclchina.com.cn/shoreExcursionNew/image/shoreBtm.png">
                                            <img class="up" src="https://resource.rcclchina.com.cn/shoreExcursionNew/image/shoreTop.png">
                                        </span>
                                    </button>
                                    <ul class="dropdown-menu menu--city" role="menu" aria-labelledby="dropdownMenu1">
                                        <li v-for="item in cityModels" :key="item.id" class="citys">
                                            <a href="javascript: void(0)" @click="handleSelectCity(item)">{{item.cityCNName}}</a>
                                        </li>
                                    </ul>
                                    <div class="dropdown-menuArrow"></div>
                                </div>
                            </div>
                            <!--城市 END-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <!--岸上观光三大理由-->
                    <div class="shore--introduce">
                        <div class="threeReasons">
                            <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/destination/2024/reason_noLucency.png" alt="三大理由">
                        </div>
                    </div>
                    <!--游览方式-->
                    <div v-if="introModels.length > 0" class="tourism--manner">
                        <div class="tourism--title">
                            <ul style="width: 13%;">
                                <li class="tourismHover" style="width: 100%;">精品游</li>
                            </ul>
                        </div>
                        <!--游览方式-->
                        <div class="tour--manner">
                            <!--精品游-->
                            <div class="boutique--tour competitive">
                                
                                <div v-for="(item,index) in introModels" :key="index" class="boutique--tour--brackets">
                                    <div class="tour--img control-direction">
                                        <div id="myCarousel0" class="carousel slide">
                                            <div class="carousel-inner">
                                                <div class="item active">
<!--                                                    <img :src="item.bannerImage" :alt="item.shorexName">-->
<!--                                                  精品游图片轮播-->
                                                  <div class="routeDetailImages">
                                                    <shore-sightsee-swiper :banner-list="item.bannerList"></shore-sightsee-swiper>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="boutique--introduce">
                                        <div class="pcpShorex-headTitle">
                                            <div class="pcpShorex-headTitle-left">
                                                <div class="boutique--title">{{item.shorexName}}</div>
                                                <div v-if="item.shorexTagShow" class="boutique--foodSign">
                                                    <img :src="item.shorexTagShow.image" :alt="item.shorexTagShow.tagName">
                                                    <span>{{item.shorexTagShow.tagName}}</span>
                                                </div>
                                            </div>
                                            <div v-if="item.recommendEnum === 1" class="boutique--hotSign">
                                                <img src="../../assets/hotIcon.png" alt="">
                                                <span>热卖推荐</span>
                                            </div>
                                        </div>
                                        <div class="pcpShorex-subTitle">{{item.shorexBrief}}</div>
                                        <div class="boutique--duration">
                                            <div class="price">价格:&nbsp;<span class="cost">{{item.shorexPrice}}</span><span class="sign">美金</span>/人</div>
                                            <div class="hour">时长：<span class="time">{{item.duration}}</span></div>
                                        </div>
                                        <div class="instruction" v-html="item.shorexDescription"></div>
                                        <div class="boutique--tour-bottom" v-if="item.cruisePartAndIntroPardApis&&item.cruisePartAndIntroPardApis.length>0">
                                            <div class="boutique--tour-recentSail">
                                                <img src="https://resource.rcclchina.com.cn/shorex/shipIcon.png" alt="">
                                                <span>
                                                    近期航次推荐：{{getCruiseTitle(item.cruisePartAndIntroPardApis)}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear: both;"></div>
                                </div>
                                <div class="relief--text">
                                    <p style="text-align:left;margin-bottom: 3px;">注：下列岸上观光信息仅供参考</p>
                                    <p style="text-align:left;margin-bottom: 3px;">1) 请以关联船票后选择的行程及其价格为准。</p>
                                    <p style="text-align:left;margin-bottom: 3px;">2) 目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</p>
                                    <p style="text-align:left;margin-bottom: 3px;">3) 目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</p>
                                    <p style="text-align:left;margin-bottom: 3px;">4) 本站以外预订，请以相关渠道信息为准。</p>
                                    <p style="text-align:left;margin-bottom: 3px;">5) 持中国大陆护照的客人，坐游轮前往韩国济州航线免签。入境首尔（仁川）、釜山港口必须持有“观光登陆许可证”或韩国个签。凡是通过皇家加勒比官方渠道预订船票且报名参加皇家岸上观光的乘客，皇家加勒比会为您办理“观光登陆许可证”。旅行社渠道预订船票的乘客，请向原订票渠道咨询岸上观光行程以及韩国“观光登陆许可证”办理事宜。</p>
                                    <p style="text-align:left;margin-bottom: 3px;">6) 皇家行前订目前只提供全程观光优惠套餐。您可于登船后购买单一港口观光产品。优惠套餐与单一港口观光产品均数量有限，先到先得。</p>
                                </div>
                            </div>

                            <!--常规游-->
                            <div class="boutique--tour routine f-dn"></div>

                            <!--私人订制游-->
                            <div class="boutique--tour own f-dn"></div>
                            <div class="booking--tickets">
                                <div class="have-booked">
                                    <div class="have-title">已经预订船票</div>
                                    <div class="have-btn">
                                        <a target="_blank" :href="`${basePCPUrl}/Rccl.PCP/product/pcpShorex`">预约岸上观光产品</a>
                                    </div>
                                </div>
                                <div class="not-booked">
                                    <div class="not-title">尚未预订船票</div>
                                    <div class="not-btn">
                                        <router-link target="_blank" :to="`/Rccl.Cruise/CruiseSearch/Search?offset=0&destinationCodes=${cityDetail.code}`">查找该目的地航线</router-link>
                                    </div>
                                </div>
                            </div>
                            <!--游览 END-->
                        </div>
                    </div>

                    <div v-else class="tourism--manner" style="padding-top:20px;">
                        <p style="margin:0 0 0 18px;font-size:14px;color:#000;font-weight:400;">温馨提示：该目的地岸上观光产品即将上线，敬请期待！</p>
                    </div>

                    <!--城市信息-->
                    <div class="urban--information f-dn">
                        <!--城市介绍-->
                        <div class="travel--tips">城市介绍</div>
                        <div class="travel--message">
                            <div class="messgae-question">
                                <p class="city-intro">{{cityDetail.descrption}}</p>
                            </div>
                            <div class="message-img">
                                <div class="sightseeing">
                                    <img :src="cityDetail.cityImageUrl" :alt="cityDetail.cityCNName">
                                </div>
                            </div>
                        </div>
                        <div class="urban--title">城市信息</div>
                        <div class="geographic--information">
                            <ul>
                                <li class="first">
                                    <span class="which--area">所属地区</span>
                                    <span class="area--name">{{cityDetail.area}}</span>
                                </li>
                                <li class="first">
                                    <span class="which--area">人口</span>
                                    <span class="area--name">{{cityDetail.population}}</span>
                                </li>
                                <li class="first areaBg">
                                    <span class="which--area">面积</span>
                                    <span class="area--name">{{cityDetail.acreage}}</span>
                                </li>
                                <li class="areaBg first">
                                    <span class="which--area">经纬度</span>
                                    <span class="area--name">{{cityDetail.position}}</span>
                                </li>
                                <li class="first">
                                    <span class="which--area">时差</span>
                                    <span class="area--name">{{cityDetail.timezone}}</span>
                                </li>
                                <li class="first">
                                    <span class="which--area">气候条件</span>
                                    <span class="area--name">{{cityDetail.climatic}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottomBanner">
                <div id="swiper-bottomBanner" class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="bottomBanner-con">
                                <div class="bottomBanner-cityPic">
                                    <img :src="cityDetail.videoImage" :alt="cityDetail.cityCNName">
                                </div>
                                <div class="bottomBanner-cityInfo">
                                    <div class="container">
                                        <div class="row">
                                            <div class="bottomBanner-cityInfo-con">
                                                <p class="bottomBanner-cityName">{{cityDetail.cityCNName}}</p>
                                                <p class="bottomBanner-cityIntro">{{cityDetail.descrption}}</p>
                                                <div class="bottomBanner-videoPlay"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import api from '@/api'
    import ShoreSightseeSwiper from "@/components/shoreSightseeSwiper.vue";
    import DestinationVideo from "@/components/Alert/DestinationVideo.vue";
    export default {
        name: 'ShorexIntroList',
        components: {
          DestinationVideo,
          ShoreSightseeSwiper
        },
        data () {
            return {
                basePCPUrl: '',
                selectedCountry: '',
                cityDetail: {},
                countryModels: [],
                countryModel: {},
                cityModels: [],
                introModels: [],
                isShowCountryDrop: false,
                isShowCityDrop: false,
                cityText: '请选择城市',
                isShowPlayBtn:true,
                swiperIndex:0,
                popupVideoUrl:''
            }
        },
        beforeMount () {
            this.initPage()
        },
        methods: {
            async initPage () {
                this.basePCPUrl = process.env.VUE_APP_PCP_URL
                const cityName = this.$route.query.cityName
                const data = await this.getCityDetail(cityName)
                this.cityDetail = data.cityPartRecordViewModel
                // this.cityModels = data.cityPartRecordViewModels
                this.countryModels = data.countryPartRecordViewModels
                this.introModels = data.shorexIntroPartRecordViewModels
                this.cityText = this.cityDetail.cityCNName

                const cityId = this.cityDetail.id
                this.countryModels.map(item => {
                    if (item.cityPartRecords) {
                        item.cityPartRecords.map(_item => {
                            if (_item.id === cityId) {
                                this.countryModel = item
                                this.cityModels = item.cityPartRecords
                            }
                        })
                    }
                })
            },
            getCruiseTitle(cruises) {
                let cruiseArray = []
                cruises.forEach((cruise)=> {
                    cruiseArray.push(cruise.shipName+cruise.sailDate)
                })
                return cruiseArray.join(' / ')
            },
            handleShowCountryDrop () {
                this.isShowCountryDrop = true
            },
            handleHideCountryDrop () {
                this.isShowCountryDrop = false
            },
            handleShowCityDrop () {
                this.isShowCityDrop = true
            },
            handleHideCityDrop () {
                this.isShowCityDrop = false
            },
            handleSelectCountry (item) {
                this.countryModel = item
                this.isShowCountryDrop = false
                this.cityModels = item.cityPartRecords
                this.cityText = '请选择城市'
            },
            handleSelectCity (item) {
                this.isShowCityDrop = false
                this.cityText = item.cityCNName
                window.location.href = `/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=${item.cityCNName}`
            },
            async getCityDetail (cityName) {
                this.$loading.show()
                const {success, data, errMsg} = await api.page.getCityDetail(cityName)
                this.$loading.hide()
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            goPrev (idx) {
              let swiper = this.$refs.bannerSwiper[idx].$swiper
              this.swiperIndex = swiper.realIndex-1
              swiper.slidePrev()
            },
            goNext (idx) {
              let swiper = this.$refs.bannerSwiper[idx].$swiper
              this.swiperIndex = swiper.realIndex+1
              swiper.slideNext()
            },
            changeSwiper(idx){
            //   获取当前滑动下标
              let swiper = this.$refs.bannerSwiper[idx].$swiper
              this.swiperIndex = swiper.realIndex
              //   获取所有class为video-content下的视频
              const videoList = document.querySelectorAll('.video-content video')
              videoList.forEach(item=>{
                item.pause()
              })
            }
        }
    }
</script>

<style lang="less" scoped>
    .shoreBanner{
        width: 100%;
        overflow: hidden;
        position: relative;
    }
    .shoreBanner img{
        width: 100%;
        height: 100%;
    }
    .shoreBanner video{
      width: 100%;
      height: 500px;
    }
    .shoreVideoBtn{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      & .video-btn{
        width: 43px;
        height: 43px;
        margin: 0 auto;
        cursor: pointer;
      }
      & .video-text{
        display: flex;
        width: 207px;
        height: 45px;
        background: #f2c543;
        gap: 7px;
        align-items: center;
        justify-content: center;
        margin-top: 47px;
        cursor: pointer;
        color:#5f5d59;
        font-size: 14px;
        & img{
          width: 18px;
          height: 18px;
        }
      }
    }
    .shore--container{
        background: #f0f0f0;
    }
    .shore--country{
        width: 1140px;
        height: 62px;
        background: #fff;
        border-radius: 5px;
        margin: 0 auto;
    }
    .contry-content{
        width: 100%;
        text-align: center;
    }
    .contrySuper{
        position: fixed;
        top:0;
        z-index: 10;
    }
    .shore--country .dropdown{
        float: left;
        width: 164px;
        height: 62px;
        .down{
            display: inline-block;
        }
        .up{
            display: none;
        }
    }
    .shore--country .dropdown:hover button{
        background: #fbc300;
    }
    .shore--country .dropdown button{
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .dropdown-menu{
        top:62px;
        max-height: 265px;
        overflow-y: auto;
    }
    .dropdown-menu li{
        height: 42px;
        line-height: 42px;
        cursor: pointer;
    }
    .shore--country .dropdown-menu li a{
        outline: none;
        height: 42px;
        line-height: 42px;
        display: inline-block;
        width: 100%;
    }
    .dropdown .dropdown-menu li:hover a{
        background: #fef3cc !important;
    }
    .introduce--reason .serve--reason{
        width: 380px;
        float: left;
    }
    .serve--reason{
        padding-top: 64px;
    }
    .serve--reason .reason--title{
        text-align: center;
    }
    .serve--reason .reason--title img{
        margin-bottom: 20px;
    }
    .serve--reason .mindService{
        color: #444b75;
        font-size: 18px;
        margin-left: 20px;
        font-weight: 500;
    }
    .service--detail{
        text-align: center;
        margin-top: 12px;
    }
    .service--detail .detail--icon{
        width: 38px;
        display: inline-block;
        float: left;
        margin: 0 28px 0 40px ;
    }
    .service--detail .detail--icon img{
        margin-top: 6px;
    }
    .service--detail .service--ensure{
        display: inline-block;
        width: 236px;
        text-align:justify;
        float: left;
        margin-right: 38px;
        color: #000000;
        max-height: 202px;
        overflow: hidden;
    }
    .tourism--manner{
        //width: 100%;
        margin: 22px auto 0;
        background: #fff;
        border-radius: 5px;
        padding-bottom: 25px;
    }
    .tourism--title{
        height: 80px;
        border-bottom: 1px solid #e5e5e5;
    }
    .tourism--title ul{
        width: 512px;
        height: 100%;
        margin: 0 auto;
        text-align: center;
    }
    .tourism--title ul li{
        width: 33%;
        height: 101%;
        float: left;
        margin: 0 auto;
        text-align: center;
        line-height: 80px;
        font-size: 16px;
        color: #b8b8b8;
        cursor: pointer;
    }
    .boutique--tour{
        width: 100%;
    }
    .boutique--tour .boutique--tour--brackets{
        padding:40px 2%;
        border-bottom: 1px solid #e5e5e5;
    }
    .brackets-border{
        border-bottom: none !important;
    }
    .boutique--tour--brackets .carousel .control-right,
    .boutique--tour--brackets .carousel .control-left{
        width: 34px;
        height: 72px;
        background: #d3a610;
        line-height: 72px;
        top:95px;
        right: 3px;
        margin-top: 94px;
    }
    .boutique--tour--brackets .control-direction .carousel .control-right,
    .boutique--tour--brackets .control-direction .carousel .control-left{
        background: #90928f;
    }
    .boutique--tour--brackets .control-direction .carousel .control-right:hover,
    .boutique--tour--brackets .control-direction .carousel .control-left:hover{
        background: #d3a610;
    }
    .boutique--tour--brackets .carousel .control-left{
        margin-left: 10px;
        cursor: pointer;
    }
    .boutique--tour--brackets .carousel .control-right{
        float: right;
        margin-right: 10px;
        cursor: pointer;
    }
    .boutique--tour--brackets .tour--img{
        width: 37.8%;
        float: left;
        overflow: hidden;
    }
    .boutique--tour--brackets .boutique--introduce{
        width: 60%;
        float: left;
        margin-left: 2%;
    }
    .relief--line{
        width:100%;
        border-top:1px dotted #e5e5e5;
        margin-top: 15px;
    }
    .relief--text{
        width: 100%;
        margin-top: 30px;
        padding: 0 0 10px 2%;
    }
    .boutique--introduce .boutique--title{
        color: #000000;
        font-weight: 600;
        font-size: 15px;
    }
    .boutique--introduce .boutique--duration{
        width: 100%;
        height: 30px;
        margin-top: 6px;
    }
    .boutique--duration .hour {
        font-size: 13px;
        color: #666666;
        float: left;
        margin-top: 3px;
        font-weight: 500;
    }
    .boutique--duration .title{
        font-size: 13px;
        color: #fab300;
        float: left;
        background: #fff8e1;
        border: 1px solid #fbc300;
        text-align: center;
        border-radius: 5px;
        padding: 3px 7px;
        margin-left: 20px;
    }
    .boutique--duration .time{
        font-size: 13px;
        color: #666666;
        font-weight: 500;
    }
    .boutique--duration .sign{
        font-size: 16px;
        color: #fab300;
    }
    .boutique--duration .price{
        font-size: 16px;
        color: #a0a0a0;
        float: right;
        line-height: 22px;
    }
    .boutique--duration .cost{
        color: #fab300;
        font-weight: 500;
        font-size: 16px;
    }
    .boutique--introduce .explain{
        width: 100%;
        color: #999999;
        overflow: hidden;
        margin-top: 15px;
    }
    .boutique--introduce .instruction {
        width: 100%;
        color: #333;
        font-size: 15px;
        overflow: hidden;
        line-height: 25px;
    }
    .boutique--introduce .booking--tickets{
        width: 100%;
        overflow: hidden;
        margin-top: 20px;
    }
    .have-booked .have-title,
    .not-booked .not-title{
        margin-bottom: 8px;
    }

    .booking--tickets {
        text-align: center;
        margin-top: 25px;
    }

    .booking--tickets .not-booked,
    .booking--tickets .have-booked {
        display: inline-block;
        width: 180px;
        height: auto;
        text-align: center;
        margin: 0 10px 0 25px;
    }
    .have-booked .have-btn,
    .not-booked .not-btn{
        width: 180px;
        height: 34px;
        background: #fbc300;
        border-radius: 5px;
        text-align: center;
        line-height: 34px;
        font-weight: 500;
        cursor: pointer;
        font-size: 14px;
    }
    .have-booked .have-btn a,
    .not-booked .not-btn a{
        color: #333;
        display: inline-block;
        width: 100%;
    }
    .boutique--tour .boutique--fontnote{
        width: 1104px;
        height: 158px;
        margin: 0 auto;
    }
    .boutique--fontnote .haveReserved{
        text-align: center;
        margin-top: 50px;
    }
    .haveReserved a{
        display: inline-block;
        width: 96px;
        height: 35px;
        border-radius: 5px;
        background: #fbc300;
        color: #333333;
        text-align: center;
        line-height: 35px;
        font-weight: 500;
    }
    .boutique--fontnote .notBooked{
        text-align: center;
        margin-top: 22px;
    }
    .urban--information{
        width: 100%;
        margin: 22px auto 0;
        background: #fff;
        border-radius: 5px;
        padding-bottom: 40px;
    }
    .urban--information .urban--title{
        width: 100%;
        height: 68px;
        padding:0 2%;
        border-bottom: 1px solid #e5e5e5;
        color: #333333;
        font-size: 16px;
        font-weight: 500;
        line-height: 68px;
    }
    .urban--information .geographic--information{
        width: 100%;
        height: 164px;
        margin: 0 auto;
    }
    .geographic--information ul{
        width: 100%;
        height: 100%;
    }
    .geographic--information ul li{
        width: 49%;
        height: 54.6px;
        border-bottom: 1px dotted #e5e5e5;
        float: left;
        overflow: hidden;
    }
    .geographic--information ul li:nth-child(2n+1){
        margin-right:2%;
    }
    .geographic--information ul li.areaBg{
        background: #f7f7f7;
    }
    li .which--area{
        display: inline-block;
        width: 98px;
        height: 54.6px;
        line-height: 54.6px;
        color: #333333;
        font-size: 14px;
        font-weight: 500;
        margin-left: 20px;
    }
    li .area--name{
        display: inline-block;
        height: 54.6px;
        line-height: 54.6px;
        color: #999999;
        font-size: 12px;
        font-weight: 500;
        margin-left: 5px;
    }
    .urban--information .travel--tips{
        width: 100%;
        height: 84px;
        padding:0 2%;
        border-bottom: 1px solid #e5e5e5;
        line-height: 94px;
        color: #333333;
        font-size: 16px;
        font-weight: 500;
    }
    .urban--information .travel--message{
        width: 100%;
        margin: 0 auto;
        padding:20px 2%;
        overflow:hidden;
    }
    .travel--message .messgae-question{
        width:42%;
        float: left;
        margin-right: 2%;
    }
    .travel--message .messgae-question .city-intro{
        margin-top: 25px;
        text-align: justify;
        padding: 0 20px;
        line-height: 25px;
        font-weight: 500;
        color: #333;
        font-size: 14px;
    }
    .travel--message .message-img{
        width: 56%;
        float: left;
    }
    .messgae-question ul{
        width: 100%;
        height: 100%;
    }
    .messgae-question ul li{
        width: 100%;
        height: 56px;
        border-bottom: 1px dotted #e5e5e5;
        line-height: 56px;
    }
    .messgae-question ul li a{
        font-size: 16px;
        font-weight: 500;
        color: #333333;
    }
    .messgae-question ul li a:hover{
        color: #051750;
        font-weight: 500;
    }
    .messgae-question ul li:first-child{
        margin-top: 6px;
    }
    .message-img .sightseeing{
        width: 100%;
        overflow: hidden;
        cursor:pointer;
    }
    .message-img .sightseeing video{
        width: 100%;
        height: 100%;
    }
    .message-img .sightseeing img{
        width: 100%;
    }
    .tourismHover{
        color: #031257 !important;
        font-weight: 500;
        border-bottom: 2px solid #fbc300;
        cursor: pointer;
    }
    .rcclQN__recommend{
        width:1140px;
        margin: 0 auto;
        padding-bottom: 20px;
    }
    .personalCenter__recommend {
        position: relative;
        margin-top: 50px;
    }
    .personalCenter__recommend .personalCenter__recommend_title {
        position: relative;
        text-align: center;
        line-height: 17px; }
    .personalCenter__recommend .personalCenter__recommend_title span {
        position: relative;
        font-size: 18px;
        padding: 0px 10px;
        z-index: 1;
        background-color: #f0f0f0;
        color: #484848;
    }
    .personalCenter__recommend .personalCenter__recommend_title .line--through {
        position: absolute;
        width: 100%;
        height: 1px;
        top: 10px;
        background-color: #d8d8d8; }
    .personalCenter__recommend .personalCenter__recommend_container {
        margin-top: 42px;
        overflow: hidden; }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content {
        width: 49%;
        overflow: hidden;
        background: #fff;
        display: inline-block;
        vertical-align: middle;
        border-radius:4px;
        margin-left: -4px;
        margin-bottom: 2%;
        margin-right: 12px;
    }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .div--inlineBlock {
        display: inline-block;
        width:128px;
    }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .personalCenter__recommend_Info {
        display: inline-block;
        margin-left: 4.8%;
        vertical-align: middle;
        margin-top: 10px;
        width:60%;
    }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .personalCenter__recommend_Info p {
        font-size: 16px; }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .personalCenter__recommend_Info .recommend--tour {
        color: #021156; }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .personalCenter__recommend_Info .recommend--data {
        color: #4c4c4c; }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .personalCenter__recommend_Info .personalCenter__recommend_price p {
        color: #fab300; }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .personalCenter__recommend_Info .personalCenter__recommend_price .personalCenter__recommend_priceTxt {
        color: #727272; }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter__recommend_content .personalCenter__recommend_Info .personalCenter__recommend_price .recommend--price {
        color: #fab300; }
    .personalCenter__recommend .personalCenter__recommend_container .personalCenter--distance {
        margin-right: 2%; }

    .reason--title .pcpShorex_reasonOrder {
        font-size: 50px;
        color: #1c75bc;
        font-weight:bold;
    }
    .reason--title .pcpShorex_reasonTitle {
        font-size: 28px;
        color: #1c75bc;
        font-weight: bold;
    }
    .service--detail p {
        font-size: 20px;
        color: #4f4f4f;
        margin: 0;
        padding: 0;
        line-height:16px;
    }
    .service--detail span {
        font-size: 14px;
        color: #8f8f90;
    }
    .service--detail p:first-child::before {
        display: inline-block;
        width: 24px;
        height: 24px;
        content: '';
        background-size: 60%;
        vertical-align: top;
    }
    .service--detail p:last-child::after {
        display: inline-block;
        width: 24px;
        height: 24px;
        content: '';
        background-size: 60%;
        margin-left: 10px;
        vertical-align: top;
    }

    .threeReasons {
        text-align: center;
    }
    .threeReasons img {
        width: 56%;
    }

    .pcpShorex-headTitle {
        overflow:hidden;
    }
    .pcpShorex-headTitle-left {
        float:left;
    }
    .pcpShorex-headTitle .boutique--title {
        display: inline-block;
        font-size:24px;
        vertical-align:middle;
    }
    .boutique--foodSign {
        padding:0 10px;
        text-align:center;
        height: 26px;
        line-height:24px;
        background-color: #050656;
        display:inline-block;
        margin-left:6px;
        vertical-align:middle;
    }
    .boutique--foodSign img {
        width:15px;
        height:14px;
        vertical-align:middle;
    }
    .boutique--foodSign span {
        color:#fff;
        font-size:14px;
        margin-left:4px;
        vertical-align:middle;
    }
    .boutique--hotSign {
        float:right;
    }
    .boutique--hotSign img{
        width:17px;
        height:22px;
        vertical-align:middle;
    }
    .boutique--hotSign span{
        font-size:14px;
        color:#f00;
        margin-left:4px;
        vertical-align:middle;
    }
    .pcpShorex-subTitle {
        font-size:15px;
        font-weight:800;
        color:#000;
        margin-top:6px;
    }
    .item-videoCon {
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        left:0;
    }
    .item-videoCon video{
        height:100%;
        transform:translateX(-35%);
        -webkit-transform:translateX(-35%);
        -moz-transform:translateX(-35%);
        -ms-transform:translateX(-35%);
        -o-transform:translateX(-35%);
        cursor:pointer;
        display:none;
    }
    .item-videoCon .item-playBtn {
        position:absolute;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
        -webkit-transform:translate(-50%,-50%);
        -moz-transform:translate(-50%,-50%);
        -ms-transform:translate(-50%,-50%);
        -o-transform:translate(-50%,-50%);
    }
    .item-videoCon .item-playBtn img{
        width:57px;
        height:57px;
        cursor:pointer;
    }

    .bottomBanner {
        margin-top: 20px;
    }
    #swiper-bottomBanner {
    }
    .bottomBanner-con {
        width:100%;
        position:relative;
        padding:3% 0;
    }
    .bottomBanner-con p{
        margin:0;
        color:#fff;
    }
    .bottomBanner-con .bottomBanner-cityPic{
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        left:0;
        overflow:hidden;
    }
    .bottomBanner-con .bottomBanner-cityPic>img{
        width:100%;
    }
    .bottomBanner-cityVideo {
        width:100%;
        position:absolute;
        left:0;
        top:0;
        display:none;
    }
    .bottomBanner-cityVideo video{
        width:100%;
        height:100%;
        cursor:pointer;
    }
    .bottomBanner-cityVideo img{
        width:57px;
        height:57px;
        position:absolute;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
        -webkit-transform:translate(-50%,-50%);
        -moz-transform:translate(-50%,-50%);
        -ms-transform:translate(-50%,-50%);
        -o-transform:translate(-50%,-50%);
        cursor:pointer;
    }
    .bottomBanner-cityCon {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .bottomBanner-cityInfo {
        position:relative;
        z-index:2;
        cursor:pointer;
    }
    .bottomBanner-cityInfo-con {
        width: 34%;
        background-color: rgba(5,6,86,.7);
        padding: 4%;
        text-align:center;
    }
    .bottomBanner-cityName {
        font-size:30px;
    }
    p.bottomBanner-cityIntro {
        font-size:14px;
        text-align:center;
        margin-top:6px;
    }
    .bottomBanner-videoPlay {
        margin-top:40px;
    }
    .bottomBanner-videoPlay img{
        width:57px;
        height:57px;
        cursor:pointer;
    }
    .bottomBanner-videoPlay p{
        font-size:15px;
        margin-top:6px;
    }

    .pcpShorex-countrySelect {
        background-color: #050656;
        padding:2% 0;
        position:relative;
    }
    .pcpShorex-countrySelect .shore--country {
        width:auto;
        height:auto;
        margin-bottom:0;
        text-align:left;
        background:none;
    }
    .pcpShorex-countrySelect .shore--country>div{
        display:inline-block;
        margin-right:70px;
    }
    .pcpShorex-countrySelect .shore--country>div>span{
        color:#fff;
        font-size:14px;
        margin-right:16px;
    }
    .pcpShorex-countrySelect-shipPic {
        width: 25%;
        min-width: 306px;
        position: absolute;
        right: 4%;
        top: 0;
        transform: translateY(-60%);
        -webkit-transform: translateY(-60%);
        -moz-transform: translateY(-60%);
        -ms-transform: translateY(-60%);
        -o-transform: translateY(-60%);
    }
    .pcpShorex-countrySelect-shipPic img{
        width:100%;
    }
    .shore--country .dropdown button {
        border-radius: 0;
        text-align: left;
        position: relative;
        background: #fbc300;
    }
    .shore--country .dropdown {
        height:43px;
        margin-left:0;
        float:none;
        display:inline-block;
    }
    .shore--country .dropdown button .dropImg {
        position:absolute;
        right:20px;
        margin-left:20px;
    }
    .shore--country .dropdown-menu {
        top:92% !important;
        border-radius:0;
        min-width:164px;
        border:none;
    }
    .shore--country .dropdown-menuArrow {
        position: absolute;
        right: 20px;
        top: 18px;
        z-index:1111;
        width: 0;
        height: 0;
        border-top: 14px solid transparent;
        border-bottom: 14px solid #fff;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        display:none;
    }
    .shore--country .dropdown.open .dropdown-menuArrow {
        display: block;
    }
    .shore--container .price {
        float:none;
        font-size:13px;
        margin-right:25px;
        display:inline-block;
        color:#666;
        font-weight:500;
    }
    .boutique--duration .cost,
    .boutique--duration .sign {
        font-size: 13px;
        color: #666;
    }
    .boutique--duration .hour {
        float:none;
        display:inline-block;
    }
    .boutique--tour-bottom {
        width:100%;
        overflow:hidden;
    }
    .boutique--tour-recentSail {
        float:left;
        margin-top:8px;
        font-size:0;
    }
    .boutique--tour-recentSail img{
        width:26px;
        height:28px;
        vertical-align:bottom;
        margin-right:6px;
    }
    .boutique--tour-recentSail span{
        font-size:13px;
        color:#666;
        vertical-align:bottom;
    }
    .product_container .product-book_item_btn {
        margin-bottom:0;
    }
    .boutique--duration .title {
        float: none;
        display: inline-block;
    }
    @media screen and (max-width: 1200px) {
        .bottomBanner-con {
            padding:2% 0;
        }
        .bottomBanner-cityInfo-con {
            width:36%;
            padding:2%;
        }
        p.bottomBanner-cityIntro {
            font-size:12px;
        }
        .bottomBanner-cityName {
            font-size:24px;
        }
        .bottomBanner-videoPlay p {
            font-size:13px;
        }
    }
    .routeDetailImages{
      position: relative;
      & .swiper-btn-right{
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translate(0, -50%);
        cursor: pointer;
        z-index: 9;
        width: 15px;
        height: 25px;
      }
      & .swiper-btn-left{
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translate(0, -50%);
        cursor: pointer;
        z-index: 9;
        width: 15px;
        height: 25px;
      }
      & img{
        width: 100%;
      }
    }
    .routeDetailSwiper{
      height: 265px;
      position: relative;
      & .routeDetail-image{
        cursor: pointer;
        & img{
          width: 100%;
          height: 100%;
        }
        & video{
          width: 100%;
          height: 100%;
          object-fit: inherit;
        }
      }
    }
    .shore--introduce{
      width: 100%;
      margin: 24px auto 0 auto;
      background: #fff;
      border-radius: 5px;
      padding: 30px 0;
    }
.content-city-video{
  width: 100%;
  height: 530px;
  margin-top: 22px;
  position: relative;
  & img{
    width: 100%;
    height: 530px;
  }
  & .video-btn{
    width: 53px;
    height: 53px;
    margin: 0 auto;
    cursor: pointer;
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%,-50%);
    & img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
